import { useState, useEffect } from "react";

/**
 * Custom hook to check if an element with a specific ID has been scrolled more than 20px.
 * @param {string} elementId - The ID of the element to observe.
 * @returns {boolean} - Returns true if the element is scrolled more than 20px, otherwise false.
 */
function useScrollCheck(elementId: string): boolean {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const element = document.getElementById(elementId);
    if (!element) {
      return;
    }

    const handleScroll = () => {
      if (element.scrollTop > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    element.addEventListener("scroll", handleScroll);
    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [elementId]);

  return isScrolled;
}

export default useScrollCheck;
